import { Routes, Route } from 'react-router-dom';
import { LoginPage } from './platform/auth/LoginPage';
import { RequireAuth } from './platform/auth/RequireAuth';
import { GameAuthGate } from './platform/auth/GameAuthGate';
import { AppShell } from './platform/layout/AppShell';
import { GamesPage } from './apps/games/GamesPage';
import { HubHomePage } from './apps/games/routing/HubHomePage';
import { APP_ROUTES } from './platform/routes/registry';
import { NotFoundPage } from './platform/layout/NotFoundPage';

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      {/*
        The games *menu* (picker) is part of the app: it keeps the platform nav
        chrome and requires a real account, like every other app. Ranked above
        `/games/*` so the bare path lands here, not in a guest session.
      */}
      <Route
        path="/games"
        element={
          <RequireAuth>
            <AppShell>
              <HubHomePage />
            </AppShell>
          </RequireAuth>
        }
      />
      {/*
        Live game *sessions* (host display + player phones) are open to guests
        via a room link: GameAuthGate signs visitors in anonymously rather than
        walling them behind a real account, and renders full-screen (no nav
        chrome) for the phone experience. The hub opens these in a new tab.
        Ranked above `/*` so it out-ranks the login-walled catch-all.
      */}
      <Route
        path="/games/*"
        element={
          <GameAuthGate>
            <GamesPage />
          </GameAuthGate>
        }
      />
      <Route
        path="/*"
        element={
          <RequireAuth>
            <AppShell>
              <Routes>
                {APP_ROUTES.map((r) => (
                  <Route key={r.key} path={r.path} element={r.render()} />
                ))}
                <Route path="*" element={<NotFoundPage />} />
              </Routes>
            </AppShell>
          </RequireAuth>
        }
      />
    </Routes>
  );
}
